import React,{useState,useEffect} from 'react';
import { check_subscription_api } from '../Services/Apis';
import Cookies from 'js-cookie';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';


const CheckPage = () => {

    const [loading,setLoading] = useState(false);


    const params = new URLSearchParams(window.location.search)

    const number = params.get('ani');
    const ext_ref = params.get('ext_ref');

    const navigate = useNavigate()


    const checkSubscription=async()=>{
          if(!number){
              setTimeout(()=>{
                window.location.href = `http://seenvd.com/api/header?ext_ref=${ext_ref}`
              },10000)
              return;
          }
          setLoading(true)
          Cookies.set('sub_number',number)
          try {
              const response = await axios.get(`${check_subscription_api}?msisdn=${number}`);
              setLoading(false);
              navigate(`/home?ext_ref=${ext_ref}`)
            //   toast.success(response.data)
            } 
            catch (error) {
              // toast.error(error.response.data)
              setLoading(false);
              setTimeout(()=>{
                navigate('/subscribe')
              },1000)
            }
            
          };
    
    
          useEffect(()=>{
             checkSubscription()
          },[])


  return (
    <div>
      
    </div>
  );
}

export default CheckPage;
